import React, { useState, useEffect } from 'react';

const LEVELS = [
  {
    id: 1,
    title: 'First Steps',
    subtitle: 'Beginner',
    description: "Perfect if you're brand new. We'll get you comfortable with the basics so you can start speaking with confidence from day one. No stress, just fun!",
  },
  {
    id: 2,
    title: 'Finding your voice',
    subtitle: 'Intermediate',
    description: "Ready to move past the basics? We'll grow your vocabulary and help you express your real personality while we chat about things you love.",
  },
  {
    id: 3,
    title: 'Natural conversation',
    subtitle: 'Advanced',
    description: "Let's polish those details! We'll dive into real-life topics and deeper conversations until speaking feels like second nature to you.",
  },
  {
    id: 4,
    title: 'Citizenship Prep',
    subtitle: 'B1 Exam',
    description: "Your big dream is almost here! I'll help you prep for the B1 exam with clear steps, lots of practice, and a solid plan to pass.",
  },
];

const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';

const sectionStyle   = { padding: '100px 8%', backgroundColor: '#FDF5E6' };
const containerStyle = { maxWidth: '1200px', margin: '0 auto', textAlign: 'center' };

const headerStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '2rem',
  letterSpacing: '5px',
  marginBottom: '60px',
  color: DEEP_MOSS,
  fontWeight: 300,
  textTransform: 'uppercase',
};

const italicAccentStyle = { color: TERRACOTTA };

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '30px',
};

const cardStyle = {
  backgroundColor: '#FFFFFF',
  padding: '40px',
  borderRadius: '12px',
  boxShadow: '0 10px 30px rgba(40, 54, 24, 0.04)',
  textAlign: 'center',
};

const cardTitleStyle = {
  fontFamily: "'Playfair Display', serif",
  fontStyle: 'italic',
  fontSize: '1.6rem',
  color: TERRACOTTA,
  marginBottom: '5px',
};

const subtitleStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.65rem',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  color: DEEP_MOSS,
  opacity: 0.5,
  marginBottom: '20px',
};

const cardDivider = {
  width: '30px',
  height: '1px',
  backgroundColor: TERRACOTTA,
  margin: '0 auto 20px',
  opacity: 0.3,
};

const bodyStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.9rem',
  lineHeight: '1.6',
  color: DEEP_MOSS,
  opacity: 0.8,
  fontWeight: 300,
};

export const Specialties = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="specialties" style={{ ...sectionStyle, padding: isMobile ? '40px 8%' : '100px 8%' }}>
      <div style={containerStyle}>
        <h2 style={{ ...headerStyle, marginBottom: isMobile ? '30px' : '60px', fontSize: isMobile ? '1.4rem' : '2rem' }}>
          WAYS WE CAN <span style={italicAccentStyle}>work</span> TOGETHER
        </h2>

      <div style={gridStyle}>
        {LEVELS.map((level) => (
          <div key={level.id} style={cardStyle}>
            <h3 style={cardTitleStyle}>{level.title}</h3>
            <p style={subtitleStyle}>{level.subtitle}</p>
            <div style={cardDivider} />
            <p style={bodyStyle}>{level.description}</p>
          </div>
        ))}
      </div>

    </div>
  </section>
);
};

// ─── Styles ───────────────────────────────────────────────────────────────────